/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { QuotationDTO } from '@api/models/.';
import { QuotationDataModel } from '@models/.';
import {
  Component,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  EventEmitter
} from '@angular/core';

@Component({
  selector: 'app-quotation-preview',
  templateUrl: './quotation-preview.component.html',
  styleUrls: ['./quotation-preview.component.scss']
})
export class QuotationPreviewComponent implements OnChanges {
  /**
   * evento emesso sul click del pulsante di modifica
   */
  @Output() edit = new EventEmitter<void>();

  /**
   * dati quotation
   */
  @Input() quotation: QuotationDTO;

  /**
   * dati primari visualizzati nella card
   */
  @Input() primaryData: QuotationDataModel[];

  /**
   * flag per visualizzare il bottone modifica
   */
  @Input() editable: boolean;

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (!!changes.quotation || !!changes.primaryData) {
      this.mapData();
    }
  }

  /**
   * evento emesso al click del bottone modifica
   */
  onEdit(): void {
    this.edit.emit();
  }

  /**
   * mappa i dati della quotation
   */
  private mapData(): void {
    this.mapPrimaryData();
  }

  /**
   * mappa i dati della quotation sulla lista di primary data
   */
  private mapPrimaryData(): void {
    this.primaryData.forEach(
      data => (data.value = this.getQuotationFieldValue(data.id))
    );
  }

  /**
   * ottiene il value del dato recuperandolo dalla quotation
   */
  private getQuotationFieldValue(fieldId: string): number {
    const value = this.quotation && this.quotation[fieldId];

    if (typeof value === 'number') {
      return value;
    } else {
      return 0;
    }
  }
}
